module.exports = __webpack_public_path__ + "avatar-neeko.5989dc11.png";